import { PseudoElementSelector } from "./pseudo-element.js";
/**
 * {@link https://drafts.csswg.org/css-pseudo/#selectordef-before}
 */
export class Before extends PseudoElementSelector {
    static of() {
        return new Before();
    }
    constructor() {
        super("before");
    }
    *[Symbol.iterator]() {
        yield this;
    }
}
(function (Before) {
    Before.parse = PseudoElementSelector.parseLegacy("before", Before.of);
})(Before || (Before = {}));
//# sourceMappingURL=before.js.map